import React,{PropTypes } from 'react'
import {connect} from 'react-redux'
import {Field, reduxForm} from 'redux-form'
import Loader from "./Loader"
import ProductInput from "./ProductInput"
import {locale} from '../locale/AppLocale';
import trim from 'validator/lib/trim';
import isEmpty from 'validator/lib/isEmpty';
import Modal from 'react-modal';
import * as authActions from '../actions/authActions';
import {NotificationManager} from '../Helpers/NotificationManager';
import {go as routerGo} from 'react-router-redux'

import Config from '../Helpers/Config';
import axios from 'axios';
import {NavLink} from "react-router-dom";

const customStyles = {
    overlay: {
        backgroundColor: 'none'
    },
    content : {
        width:400,
        overflow                   : '',
        top                   : '',
        left                  : '',
        right                 : '',
        bottom                : '',
        marginRight           : '',
        transform             : '',
        padding             : '',
        border             : '',
        background             : '',
        borderRadius             : '',
    }
};

const validateLogin = (values, props) => {
    const errors = {};
    if (!values.email || isEmpty(trim(values.email))) {
        errors.email = locale.get('email_is_required');
    }

    if (!values.password || isEmpty(trim(values.password))) {
        errors.password = locale.get('password_is_required');
    }
    return errors;
}

class FinancialBankDetailsPopUp extends React.Component {

    constructor(props){
        super(props)
        this.state = {
            modalIsOpen: props.isOpen || false
        };
        this.openModal = this.openModal.bind(this);
        this.afterOpenModal = this.afterOpenModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
    }

    onSubmit(values) {
        validateLogin(values);
        this.props.login(values,(dataStatus) => {
            if(this.props.auth.relogin_reload){
                this.props.reloadCurrentPage(this.props.router.location.pathname);
            }else{
                NotificationManager.success(locale.get('relogin_success'))
            }

        })
    }

    openModal() {
        this.setState({modalIsOpen: true});
    }

    afterOpenModal() {
    }

    closeModal() {
        this.setState({modalIsOpen: false});
    }

    render(){

        return (
        <Modal
            portalClassName={`shooq-modal ${this.props.className || ``}`}
            isOpen={this.state.modalIsOpen}
            onAfterOpen={this.afterOpenModal}
            onRequestClose={this.closeModal}
            style={customStyles}
            shouldCloseOnOverlayClick={false}
            contentLabel="Example Modal"
        >
            <div className="shooq-modal--box">
                <div className="shooq-modal--header">
                    <div className="shooq-modal--header--title">{locale.get('manage_bank')}</div>
                </div>
                <div className="clearfix"/>
                <div className="shooq-modal--body">
                    <p>{locale.get('please_fill_your_bank_details_to_access_to_financial_area')}</p>
                    <p>
                        <NavLink to={`/${this.props.businessSlug}/financial/bank`}>{ locale.get('click_here_to_go_to_manage_banks')}</NavLink>
                    </p>
                </div>
                <div className="clearfix"/>
            </div>
        </Modal>
        )

    }

    componentDidMount() {
        const receiveMessage = (event) => {
            this.props.facebookLoginFailed();
            if(event){
                if (event.data === 'facebook_logged_in') {
                    if(this.props.auth.relogin_reload){
                        this.props.reloadCurrentPage(this.props.router.location.pathname);
                    }else{
                        this.props.check()
                        NotificationManager.success(locale.get('relogin_success'))
                    }
                } else {
                    // NotificationManager.error(locale.get('facebook_login_failed'))
                }
            }
        };

        if (window.addEventListener) {
            window.addEventListener("message", receiveMessage, false);
        } else {
            window.attachEvent("onmessage", receiveMessage);
        }
    }

}

// Maps state from store to props
const mapStateToProps = (state, ownProps) => {
    return {
        auth: state.auth,
        router:state.router
    }
};

// Maps actions to props
const mapDispatchToProps = (dispatch,ownProps,ownProps12) => {
    return {
        login: (data,callback = ()=>{}) => dispatch(authActions.login(data,callback,false)),
        check: () => dispatch(authActions.check()),
        facebookLoginFailed: () => dispatch({
            type: 'AUTH_LOGIN_FAILED',
            results: {}
        }),
        reloadCurrentPage: (pathname) => dispatch(routerGo("/heijar-tailoring-store/orders/2"))
    }
};

// FinancialBankDetailsPopUp.propTypes = {
//     isOpen: PropTypes.bool
// }

FinancialBankDetailsPopUp = reduxForm({
    form: 'loginForm',
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
    touchOnChange: true,
    validate: validateLogin,
})(FinancialBankDetailsPopUp);


export default connect(mapStateToProps, mapDispatchToProps)(FinancialBankDetailsPopUp);
